import { BeamNetworkCallEvent } from "./events";

/**
 * Fetch Listener
 */

const fetchHandler = {
  apply: function (target: any, _thisArg: any, args: any[]) {
    return target(...args).then((response: Response) => {
      if (response.ok) {
        const responseCopy = response.clone();
        window.dispatchEvent(
          new BeamNetworkCallEvent({
            url: args[0].toString(),
            method: (args[1]?.method || "get").toLowerCase(),
            type: "fetch",
            response: responseCopy,
          })
        );
      }
      return response;
    });
  },
};

/**
 * XMLHTTPRequest Listener
 */
const xhrHandler = {
  construct(TargetConstructor: any, args: any[]) {
    const xhr: XMLHttpRequest = new TargetConstructor(...args);
    const _open: (method: string, url: string | URL) => void = xhr.open;
    let _method: string;
    let _url: string | URL;

    xhr.open = function (method: string, url: string | URL) {
      _method = method;
      _url = url;
      // @ts-expect-error arguments is untyped since xhr.open is an overloaded method
      // eslint-disable-next-line prefer-rest-params
      _open.apply(this, arguments);
    };

    xhr.addEventListener("load", () => {
      window.dispatchEvent(
        new BeamNetworkCallEvent({
          url: (_url || "").toString(),
          method: (_method || "get").toLowerCase(),
          type: "xhr",
          xhr,
        })
      );
    });

    return xhr;
  },
};

/**
 * Side-Effects Setup (initialize listeners)
 */

let initializedListeners = false;

export const initNetworkListeners = () => {
  if (initializedListeners) return;
  window.fetch = new Proxy(window.fetch, fetchHandler);
  XMLHttpRequest = new Proxy(XMLHttpRequest, xhrHandler);
  initializedListeners = true;
};
